module.exports = __webpack_public_path__ + "media/images/boy-map-b4d5c122ebf158dd4cff7ef30e85c4ec.jpg";